import PNotify from "pnotify/dist/es/PNotify";
import "pnotify/dist/es/PNotifyButtons"; // habilita o botão de fechar

document.addEventListener("turbo:load", () => {
  window.PNotify = PNotify;

  PNotify.defaults.styling = "bootstrap4";
  PNotify.defaults.icons = "fontawesome5";
  PNotify.defaults.stack = {
    dir1: "down",
    dir2: "left",
    firstpos1: 42,
    firstpos2: 42,
  };
  PNotify.defaults.delay = 5000;
  PNotify.defaults.closer = true;
  PNotify.defaults.closerHover = false;
});

const pendingMessages = []; // Keeps flash notices until Turbo finished rendering
const FLASH_NODE_ID = "pnotify-flashes";

const flushPendingMessages = () => {
  if (!window.PNotify) return;

  while (pendingMessages.length > 0) {
    const { type, message } = pendingMessages.shift();
    if (!type || !message) continue;
    const notifier = window.PNotify[type];
    if (typeof notifier === "function") notifier(message);
  }
};

const enqueueNotification = (detail = {}) => {
  pendingMessages.push(detail);
  flushPendingMessages();
};

const readServerFlashes = () => {
  const node = document.getElementById(FLASH_NODE_ID);
  if (!node) return [];

  try {
    const data = JSON.parse(node.textContent || "[]");
    node.textContent = "[]";
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Failed to parse pnotify flashes", error);
    node.textContent = "[]";
    return [];
  }
};

const hydrateServerFlashes = () => {
  readServerFlashes().forEach(enqueueNotification);
};

const clearFlashNode = () => {
  const node = document.getElementById(FLASH_NODE_ID);
  if (node) node.textContent = "[]";
};

window.addEventListener("pnotify:flash", (event) => {
  enqueueNotification(event.detail);
});

hydrateServerFlashes();

if (window.Turbo) {
  document.addEventListener("turbo:render", () => {
    hydrateServerFlashes();
    flushPendingMessages();
  });

  document.addEventListener("turbo:before-cache", () => {
    clearFlashNode();
    if (typeof window.PNotify.closeAll === "function") {
      window.PNotify.closeAll();
    }
  });
} else {
  document.addEventListener("DOMContentLoaded", () => {
    hydrateServerFlashes();
    flushPendingMessages();
  });
}
